import {
  GET_CHECKOUT_DETAILS_PENDING,
  GET_CHECKOUT_DETAILS_SUCCESS,
  GET_CHECKOUT_DETAILS_FAILURE,
} from '../actions/checkoutDetails';

export const checkoutDetails = (state = {}, action) => {
  switch (action.type) {
    case GET_CHECKOUT_DETAILS_PENDING: {
      return {
        ...state,
        isLoading: true
      };
    }

    case GET_CHECKOUT_DETAILS_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    }

    case GET_CHECKOUT_DETAILS_FAILURE: {
      return {
        ...state,
        response: action.response,
        isLoading: false,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/client/js/store/reducers/checkoutDetails.js